// extracted by mini-css-extract-plugin
export default {"form__icon":"ReadSettings_form__icon__8h5TK","form":"ReadSettings_form__Li+Q1"};